import {BookingModel} from "../../booking.model";
import {CardNetworksEnum, PaymentMethodCodesEnum} from "./payment-method-codes.enum";
import {VisaNetworkModel} from "./card/networks/visa-network.model";
import {MastercardCardNetworkModel} from "./card/networks/mastercard.card-network.model";
import {MaestroCardNetworkModel} from "./card/networks/maestro.card-network.model";
import {ApplePayMethodModel} from "./apple-pay/apple-pay-method.model";
import {GooglePayMethodModel} from "./google-pay/google-pay-method.model";
import {PaypalPaymentMethodModel} from "./paypal/paypal-payment-method.model";
import {RevolutPaymentMethodModel} from "./revolut/revolut-payment-method.model";
import {IataPayPaymentMethodModel} from "./iata-pay/iata-pay-payment-method.model";
import {DinersCardNetworkModel} from "./card/networks/diners.card-network.model";
import {DiscoverCardNetworkModel} from "./card/networks/discover.card-network.model";
import {CardNetworkModel} from "./card/networks/card-network.model";
import {CardMethodModel} from "./card/card-method.model";
import {PspCodesEnum} from "./psp-codes.enum";
import {IPaymentMethodModel} from "./payment-method.model.interface";


export class PaymentMethodFactory {
    public static createPaymentMethod(booking: BookingModel, code: PaymentMethodCodesEnum, pspCode: PspCodesEnum, supportedCardNetworks: CardNetworksEnum[]): IPaymentMethodModel | null {
        switch (code) {
            case PaymentMethodCodesEnum.Card:
                return new CardMethodModel(booking, code, pspCode, PaymentMethodFactory.createSupportedCardNetworksModels(supportedCardNetworks))
            case PaymentMethodCodesEnum.ApplePay:
                return new ApplePayMethodModel(booking, code, pspCode, []);
            case PaymentMethodCodesEnum.GooglePay:
                return new GooglePayMethodModel(booking, code, pspCode, []);
            case PaymentMethodCodesEnum.PayPal:
                return new PaypalPaymentMethodModel(booking, code, pspCode, []);
            case PaymentMethodCodesEnum.Revolut:
                return new RevolutPaymentMethodModel(booking, code, pspCode, []);
            case PaymentMethodCodesEnum.IataPay:
                //return new IataPayPaymentMethodModel(booking, code, pspCode, []);
                return null;
            default:
                return null;

        }
    }

    public static createSupportedCardNetworksModels(supportedCardNetworks: CardNetworksEnum[]): CardNetworkModel[] {
        const models: CardNetworkModel[] = [];
        for(let code of (supportedCardNetworks ?? [])) {
            const n = PaymentMethodFactory.createCardNetworkModel(code);
            if(n) {
                models.push(n);
            }
        }
        return models;
    }

    private static createCardNetworkModel(code: CardNetworksEnum): CardNetworkModel | null {
        switch (code) {
            case CardNetworksEnum.Visa:
                return new VisaNetworkModel();
            case CardNetworksEnum.MasterCard:
                return new MastercardCardNetworkModel();
            case CardNetworksEnum.Maestro:
                return new MaestroCardNetworkModel();
            case CardNetworksEnum.Diners:
                return new DinersCardNetworkModel();
            case CardNetworksEnum.Discover:
                return new DiscoverCardNetworkModel();
            default:
                return null;
        }
    }
}